import app from "../_app";


const navObserver = function (event) {

    const nav = document.querySelector('.js-nav');
    
    if (nav && app.viewport.isEqualOrGreaterThan('lg')) {

        const navItems = [...document.querySelectorAll('.js-nav-item')];

        navItems.map(navItem => navItem.parentNode.addEventListener('mouseover', () => {
            let subMenu = navItem.parentNode.querySelector('.js-nav-megamenu');
            // clearTimeout(subMenu.dataset.timeoutId);
            subMenu.setAttribute('data-open', '');
        }))

        navItems.map(navItem => navItem.parentNode.addEventListener('mouseout', () => {
            let subMenu = navItem.parentNode.querySelector('.js-nav-megamenu');
            subMenu.removeAttribute('data-open', '')
        }))

    
        

    } else if (nav && app.viewport.isEqualOrSmallerThan('lg')) {

        const navItems = [...document.querySelectorAll('.js-nav-item')];

        navItems.map(navItem => navItem.addEventListener('click', (e) => {
            e.preventDefault();
            let subMenu = navItem.parentNode.querySelector('.nav__links--sub');
            subMenu.setAttribute('data-open', '');
        }))
        
        const backButtons = [...document.querySelectorAll('.js-nav-back')];
        
        backButtons.map(backBtn => backBtn.addEventListener('click', () => {
            let subMenu = backBtn.closest('.nav__links--sub');
            
            if (subMenu.hasAttribute('data-open')) {
                subMenu.removeAttribute('data-open');
            }
        }))
        
        const openMenuButton = document.querySelector('.js-nav-open');
        
        openMenuButton.addEventListener('click', () => {
            
            app.lockBody();
            nav.setAttribute('data-open', '');
        })

        const closeMenuButton = document.querySelector('.js-nav-close');

        closeMenuButton.addEventListener('click', () => {
            if (nav.hasAttribute('data-open')) {
                nav.removeAttribute('data-open');
                app.unlockBody();
            }
        })

    }

}

document.addEventListener('DOMContentLoaded', navObserver, false)
window.addEventListener('resize', navObserver, false)
